module.exports = __webpack_public_path__ + "img/trophy-all-people.6e9200e4.png";